import React, { Component } from "react";
import { Text } from "react-internationalization";
import { connect } from "react-redux";
import { ILS_CONSTS, VERDA_CONSTS } from "../Utils/StaticData/Constant";
import { LANG } from "./translations/dynamic";
class PreviewPageStep2 extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  async componentDidMount() {
    let filteredMainqns = this.props.selectedAttestation?.filter(
      (qs) => qs.answer === "yes"
    );
    let filteredSub = this.props.selectedAttestation?.filter(
      (qs) => qs.answer != "yes"
    );
    await this.setState({
      filteredMainqns: filteredMainqns,
      filteredSub: filteredSub,
    });
    let filteredqsns =
      filteredMainqns &&
      filteredMainqns?.map((element) => {
        return this.props.qsns?.filter(
          (qs) => qs.questionId === element.qsnMetaId
        )[0];
      });
    let filteredqsnsfirstQnId =
      filteredqsns && filteredqsns?.length > 1 && filteredqsns[0]?.questionId;
    await this.setState({
      filteredqsns: filteredqsns,
      filteredqsnsfirstQnId: filteredqsnsfirstQnId,
    });
  }
  render() {
    return (
      <React.Fragment>
        {this.state.filteredqsns?.length > 0 ? (
          <div>
            <label class="control-label mt-3">
              <strong>
                <Text id="step4Agent.attestinfo" />
                &nbsp;
                <a onClick={this.props.changeToSection2} class="cursor-pointer">
                  <i class="fas fa-edit"></i>
                </a>
              </strong>
            </label>
            <div>
              <ul
                class="list-group attestation-container-mobile-aligner"
                id="step3_checklist"
              >
                <li class="list-group-item">
                  <div class="custom-control custom-checkbox custom-control-inline display-block">
                    <div class="display-block">
                      {this.state.filteredqsns &&
                        this.state.filteredqsns?.map(
                          (qsns, index) =>
                            !qsns?.subQuestion && (
                              <>
                                <div
                                  class={
                                    qsns?.questionText?.length > 127
                                      ? "attestation"
                                      : "attestation1"
                                  }
                                >
                                  <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id={qsns?.questionId}
                                    name={qsns?.questionId}
                                    value={qsns?.questionId}
                                    checked={true}
                                    // onChange={(e) =>
                                    //   this.handleOnChange(
                                    //     e,
                                    //     index,
                                    //     qsns.questionId,
                                    //     qsns.selected
                                    //   )
                                    // }
                                    disabled={true}
                                    autoComplete="off"
                                    spellcheck="false"
                                    aria-autocomplete="both"
                                    aria-haspopup="false"
                                  />
                                  {this.state?.filteredqsns?.length > 1 &&
                                  index > 0 ? (
                                    <hr class="qsnsunderline" />
                                  ) : (
                                    ""
                                  )}
                                  <label
                                    class="custom-control-label"
                                    for={qsns?.questionId}
                                  >
                                    <strong>
                                      {this.props.lang === "es" &&
                                      LANG.ATTESTATIONS[qsns.questionText]
                                        ? LANG.ATTESTATIONS[qsns.questionText]
                                        : qsns.questionText}
                                    </strong>
                                  </label>
                                  {/* {console.log("dddd",qsns.questionText)} */}
                                  {console.log(
                                    "this.props.customerId",
                                    this.props.customerId,
                                    ILS_CONSTS.ID
                                  )}
                                  {qsns?.questionText === "Other" &&
                                    this.props.customerId === ILS_CONSTS.ID && (
                                      <input
                                        type="text"
                                        class="form-control"
                                        id={"otherId"}
                                        name={"attestationOther"}
                                        value={
                                          this.props.data?.attestationOther
                                        }
                                        //   onChange={(event)=>{if (
                                        //     event.target.value !== "" &&
                                        //     !DataValidation.test(event.target.value)
                                        //   ) {
                                        //     return;
                                        //   }
                                        //   this.props.handleChange(event);
                                        // }
                                        // }
                                        disabled={!qsns?.selected}
                                        style={{ border: "1px solid #999" }}
                                      />
                                    )}
                                </div>

                                {/* <br /> */}

                                {qsns?.dateInd === "y" ? (
                                  <React.Fragment>
                                    <label
                                      for="questionDate"
                                      class="attestmargin"
                                    >
                                      {/* <Text id="step3.movedate" />* */}
                                      {/* Insert Date* */}
                                      {/* {qsns.answersvo.length &&
                                  this.props.qsns[
                                    qsns.answersvo[0].subQuestions - 1
                                  ].questionText} */}
                                      {qsns.answersvo.length &&
                                      this.props.lang === "es" &&
                                      LANG.ATTESTATIONS.SUBQUESTION[
                                        this.props.qsns.filter(
                                          (el) =>
                                            el.questionId ===
                                            qsns.answersvo[0].subQuestions
                                        )[0].questionText
                                      ]
                                        ? LANG.ATTESTATIONS.SUBQUESTION[
                                            this.props.qsns.filter(
                                              (el) =>
                                                el.questionId ===
                                                qsns.answersvo[0].subQuestions
                                            )[0].questionText
                                          ]
                                        : this.props.qsns.filter(
                                            (el) =>
                                              el.questionId ===
                                              qsns.answersvo[0].subQuestions
                                          )[0].questionText}
                                      <input
                                        type="input"
                                        disabled={true}
                                        id={
                                          this.state.filteredqsns[index]
                                            ?.answersvo[0]?.subQuestions
                                        }
                                        name="questionDate"
                                        value={
                                          this.state?.filteredSub?.length > 0
                                            ? this.state?.filteredSub?.filter(
                                                (data2) =>
                                                  data2.qsnMetaId ===
                                                  this.state.filteredqsns[index]
                                                    ?.answersvo[0]?.subQuestions
                                              )[0]?.answer
                                            : ""
                                        }
                                        // class=""
                                        placeholder="MM/DD/YYYY"
                                        maxLength="10"
                                        // onChange={(e) => {
                                        //   //this.props.handleDates("questionDate")

                                        //   this.props.handleAttestationDate(
                                        //     e,this.props.qsns[index]
                                        //       ?.answersvo[0]?.subQuestions
                                        //   );
                                        // }}
                                        // onClick={(e) => {
                                        //   //this.props.handleDates("questionDate")

                                        //   this.props.qsnsDate(
                                        //     this.props.qsns[index]
                                        //       ?.answersvo[0]?.subQuestions
                                        //   );
                                        // }}
                                        className={
                                          "form-control display-inline"
                                        }
                                        autoComplete="off"
                                        spellcheck="false"
                                        aria-autocomplete="both"
                                        aria-haspopup="false"
                                      />
                                    </label>
                                  </React.Fragment>
                                ) : null}
                              </>
                            )
                        )}
                      {this.state?.filteredqsns.some(
                        (s) => s?.questionId === "42"
                      ) &&
                        this.props.customerId === VERDA_CONSTS.ID && (
                          <>
                            <div className="attestation">
                              <p>
                                <span>Please specify the following:</span>
                              </p>
                              <span>
                                Weather-related emergency or major disaster:
                              </span>
                              {"  "}
                              <input
                                type="text"
                                value={
                                  this.props.data?.attestationMajorDisaster
                                }
                                className="form-control verda-attestation"
                                name="attestationMajorDisaster"
                                id="attestationMajorDisaster"
                                disabled
                              />
                              <span>Election period missed:</span>
                              {"  "}
                              <input
                                type="text"
                                value={
                                  this.props.data?.attestationElectionMissed
                                }
                                className="form-control verda-attestation"
                                name="attestationElectionMissed"
                                id="attestationElectionMissed"
                                disabled
                              />
                            </div>
                          </>
                        )}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    qsns: state.webApp.qsns,
    customerId: state.login.customerId,
    lang: state.webApp.language,
  };
};
export default connect(mapStateToProps)(PreviewPageStep2);
